import Page from 'v5/MyDashboardPageRelay.bs'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'
import { withMainLayoutFlex } from '../../pagesComponents/MainApp'

const MyDashboardpage = requireAuthenticatedAgent(Page)

MyDashboardpage.getLayout = withMainLayoutFlex

export default MyDashboardpage
